import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import tokeyImg from '../assets/tokey.jpg';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    
    // Check if the current path is a quiz page (Reading, Listening, or Writing)
    // Giữ nguyên logic kiểm tra trang để hiển thị Timer
    const isQuizPage = location.pathname.includes('/reading') || 
                       location.pathname.includes('/listening') || 
                       location.pathname.includes('/writing');

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        navigate('/login', { replace: true });
    };

    return (
        <header className="main-app-header">
            <div className="header-inner">
                {/* Branding Section - Cute & Motivational Style */}
                <div className="branding-block" onClick={() => navigate('/dashboard')}>
                    <div className="brand-avatar">🌟</div>
                    <div className="brand-info">
                        <h1 className="brand-title">IELTS EXAM PRO</h1>
                        <span className="brand-slogan">Believe in yourself! ✨</span>
                    </div>
                </div>

                {/* Conditional Rendering: Quiz Mode vs Dashboard Mode */}
                {isQuizPage ? (
                    <div className="quiz-status-bar">
                        <div className="timer-pill">
                            <img src={tokeyImg} alt="Mascot" className="mascot-mini" />
                            <span className="time-left">⏳LET'S START</span>
                        </div>
                    </div>
                ) : (
                    <div className="user-nav-block">
                        <div className="student-profile">
                            <div className="student-avatar-box">
                                {user?.fullname?.charAt(0).toUpperCase() || 'S'}
                            </div>
                            <div className="student-text">
                                <span className="greeting">Keep going,</span>
                                <span className="full-name">{user?.fullname || 'Student'}</span>
                            </div>
                        </div>
                        <button className="signout-button" onClick={handleLogout}>
                            <span className="signout-icon">↩️</span>
                            Sign Out
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;